export default __webpack_public_path__ + "stumbler-third.af234509.mp4";